import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { RegisterPageRoutingModule } from "./register-routing.module";

import { RegisterPage } from "./register.page";
import { TranslateModule } from "@ngx-translate/core";
import { EmailSendedMessageModule } from "src/app/public/_component/email-sended-message/email-sended-message.module";
import { InputsModule } from "src/app/_component/inputs/inputs.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    RegisterPageRoutingModule,
    TranslateModule,
    EmailSendedMessageModule,
    InputsModule
  ],
  declarations: [RegisterPage],
})
export class RegisterPageModule {}
